"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalPaymentChoiceWordingWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var plugin_support_1 = require("@falcon/plugin-support");
var SupportPortalPaymentChoiceWordingWidget = /** @class */ (function (_super) {
    __extends(SupportPortalPaymentChoiceWordingWidget, _super);
    function SupportPortalPaymentChoiceWordingWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            remainingAmountPresent: true,
            dataLoaded: false,
        };
        return _this;
    }
    SupportPortalPaymentChoiceWordingWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        this.supportPortalService.getCombinedInstalmentsInfoByPartyReference(interaction.userReference)
            .subscribe(function (instalmentsInfo) {
            if (instalmentsInfo) {
                var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                _this.setState({
                    remainingAmountPresent: remainingAmountPresent,
                    dataLoaded: true
                });
            }
        });
    };
    SupportPortalPaymentChoiceWordingWidget.prototype.render = function () {
        if (this.state.dataLoaded) {
            var showRenewalPayFullPriceWording = !this.state.remainingAmountPresent && this.props.interaction.uistate.renewalWindow;
            return ((0, jsx_runtime_1.jsxs)("div", { children: [!showRenewalPayFullPriceWording &&
                        (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-bold mb-0", children: "for your changes to cover you from the start date selected to the end of your policy." }), (0, jsx_runtime_1.jsx)("p", { className: "text-center pt-2", children: "All figures include Insurance Premium Tax" }), showRenewalPayFullPriceWording &&
                        (0, jsx_runtime_1.jsx)("p", { className: "text-center pt-2", children: "As you have no outstanding monthly payments left, this amount will need to be paid on a card now." })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_support_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], SupportPortalPaymentChoiceWordingWidget.prototype, "supportPortalService", void 0);
    return SupportPortalPaymentChoiceWordingWidget;
}(plugin_journey_1.WidgetBase));
exports.SupportPortalPaymentChoiceWordingWidget = SupportPortalPaymentChoiceWordingWidget;
//# sourceMappingURL=SupportPortalPaymentChoiceWordingWidget.js.map